import { render, staticRenderFns } from "./SettingDialog.vue?vue&type=template&id=65060f68&scoped=true"
import script from "./SettingDialog.vue?vue&type=script&lang=js"
export * from "./SettingDialog.vue?vue&type=script&lang=js"
import style0 from "./SettingDialog.vue?vue&type=style&index=0&id=65060f68&prod&scoped=true&lang=scss"
import style1 from "./SettingDialog.vue?vue&type=style&index=1&id=65060f68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65060f68",
  null
  
)

export default component.exports